export default __webpack_public_path__ + "static/media/5238.8dec1268.png";